import { getConsentPlayfulProbability } from "./utils/getConsentPlayfulProbability";

export const ENV = {
  FEATURE_FLAGS: {
    offersCaching: false,
    redirect: false,
    moreFilters: false,
    isMapAvailable: process.env.IS_MAP_AVAILABLE === "true",
    useMbopQueries: process.env.USE_MBOP_QUERIES === "true",
    consentPlayfulProbability: getConsentPlayfulProbability(),
    showRoomsGuestsFilter: process.env.ROOMS_GUESTS_FILTER_ENABLED === "true",
    // sandboxEnabled: process.env.SANDBOX_ENABLED === "true",
    sandboxEnabled: true,
  },
};
